import {
  ArrowLeftIcon,
  Box,
  Heading,
  Link,
  Text,
} from '@joinrepublic/dls-ui-kit';

export const CategoryList = ({
  items,
}: {
  items: { label: string; url: string }[];
}) => (
  <>
    {items.map((item, i) => (
      <CategoryRow
        key={item.label}
        label={item.label}
        last={i === items.length - 1}
        url={item.url}
      />
    ))}
  </>
);

export interface ICategoryColumnProps {
  heading: string;
  variant: 'light' | 'mid';
  items: { label: string; url: string }[];
}

export const CategoryColumn = function CategoryColumn({
  heading,
  items,
}: ICategoryColumnProps) {
  return (
    // TODO: https://linear.app/republic/issue/USMKT-1457/change-all-hardcoded-colours-for-the-new-hp-to-the-proper-tokens
    <Box borderTop="1px solid" borderColor="whiteAlpha.500" flex="1 0">
      <Heading
        color="white"
        size="title-sm"
        fontWeight="semibold"
        mt="6"
        mb="7"
      >
        {heading}
      </Heading>
      <CategoryList items={items} />
    </Box>
  );
};

export interface ICategoryRowProps {
  label: string;
  last: boolean;
  url: string;
}

export const CategoryRow = ({ label, last, url }: ICategoryRowProps) => {
  return (
    <Link
      href={url}
      display="flex"
      alignItems="center"
      gap="1"
      py="3"
      role="group"
      borderTop="1px solid"
      // TODO: https://linear.app/republic/issue/USMKT-1457/change-all-hardcoded-colours-for-the-new-hp-to-the-proper-tokens
      borderColor="whiteAlpha.200"
      borderBottom={!last ? 'none' : '1px solid'}
      borderBottomColor={{ base: 'transparent', sm: 'whiteAlpha.200' }}
      position="relative"
      textDecoration="none"
      transition={{ md: 'padding-left .25s ease' }}
      _hover={{ textDecoration: 'none', pl: { md: '2.5' } }}
    >
      <ArrowLeftIcon
        aria-hidden
        color="blue.500"
        display={{ base: 'none', md: 'block' }}
        opacity={0}
        pointerEvents="none"
        position="absolute"
        left={0}
        boxSize={4}
        transition="opacity .25s, transform .25s"
        transform="rotate(180deg) translateX(-16px)"
        _groupHover={{
          md: {
            opacity: 1,
            pointerEvents: 'auto',
            transform: 'rotate(180deg) translateX(0)',
          },
        }}
        _focusVisible={{
          opacity: 1,
          pointerEvents: 'auto',
          transform: 'rotate(180deg) translateX(0)',
        }}
      />
      <Text
        size="body-md"
        width="100%"
        pl={0}
        textAlign="left"
        color="white"
        transition="color .2s ease, padding-left .25s ease"
        _groupHover={{ md: { pl: 3 } }}
        _focusVisible={{ md: { pl: 3 } }}
      >
        {label}
      </Text>
    </Link>
  );
};
